import React, { useState } from 'react';
import PlatformButton from './PlatformButton';
import { WORKSPACE_PRODUCTS, hasProduct } from '../lib/products';

function ProductsSection({ enabledProducts = [], onToggle }) {
  const [error, setError] = useState(null);
  const [busyId, setBusyId] = useState(null);

  const handleToggle = async (productId, enable) => {
    setError(null);
    setBusyId(productId);
    const result = await onToggle?.(productId, enable);
    setBusyId(null);
    if (!result?.ok) {
      setError(result?.error || 'Could not update product.');
    }
  };

  return (
    <div>
      <p style={{ fontSize: 14, color: 'var(--muted)', margin: '0 0 18px', maxWidth: 520 }}>
        Add products to your workspace to show them in the sidebar.
      </p>
      {error && (
        <p className="settings-inline-error" role="alert">
          {error}
        </p>
      )}
      <div className="settings-products-grid">
        {WORKSPACE_PRODUCTS.map((product) => {
          const enabled = hasProduct(enabledProducts, product.id);
          return (
            <div key={product.id} className="platform-card settings-product-card">
              <div>
                <div style={{ fontSize: 15, fontWeight: 700 }}>{product.label}</div>
                <p style={{ fontSize: 13, color: 'var(--muted)', margin: '6px 0 0', lineHeight: 1.5 }}>
                  {product.description}
                </p>
                {enabled && (
                  <p style={{ fontSize: 12, fontWeight: 600, color: 'var(--primary)', margin: '10px 0 0' }}>
                    Added · visible in navigation
                  </p>
                )}
              </div>
              <PlatformButton
                size="sm"
                variant={enabled ? 'outline' : 'primary'}
                disabled={busyId === product.id}
                onClick={() => handleToggle(product.id, !enabled)}
              >
                {enabled ? 'Remove' : 'Add'}
              </PlatformButton>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ProductsSection;
